// extracted by mini-css-extract-plugin
module.exports = {"tm-container":"teamMembers_tm-container__1h36D","tm-content":"teamMembers_tm-content__2IeQL","tm-name":"teamMembers_tm-name__1sj1w","tm-image":"teamMembers_tm-image__369nl"};